module.exports = __webpack_public_path__ + "img/bg6.70b0365a.jpg";